export { UI_MODES, type UiMode } from '@routr/shared'

/** Simple mode renames a few things rather than only hiding them. */
export function term(advanced: boolean, key: 'runSheet' | 'packList' | 'powerPlan'): string {
  if (advanced) return key === 'runSheet' ? 'Run sheet' : key === 'packList' ? 'Pack list' : 'Power plan'
  return key === 'runSheet' ? 'Cable list' : key === 'packList' ? 'What to bring' : 'Power needed'
}
